import { Text } from '@thanx/uikit/text'
import palette from 'constants/palette'
import React from 'react'
import { useStyletron } from 'styletron-react'

const CELL_PADDING = '16px 0'
const HAIRLINE = `1px solid ${palette.grey20}`

// Style objects are module-level exports so tests can assert the two
// load-bearing layout deltas (value right-aligned, label regular weight)
// directly — renderWithStore has no StyletronProvider, so css() → '' in the DOM.
export const rowStyle = { borderBottom: HAIRLINE }
export const labelCellStyle = {
  padding: CELL_PADDING,
  textAlign: 'left' as const,
  verticalAlign: 'top' as const,
  fontWeight: 'normal' as const,
}
export const valueCellStyle = {
  padding: CELL_PADDING,
  textAlign: 'right' as const,
}

type Props = {
  // label/value/subLine are already-translated strings, not JSX. Renders one
  // <tr>, so this must be used inside a <tbody>.
  label: string
  value: string
  subLine?: string
}

const SummaryDetailRow = ({ label, value, subLine }: Props) => {
  const [css] = useStyletron()
  return (
    <tr className={css(rowStyle)}>
      <th scope="row" className={css(labelCellStyle)}>
        <Text.BodyText4 color="grey70">{label}</Text.BodyText4>
      </th>
      <td className={css(valueCellStyle)}>
        <Text.BodyText4 color="grey90">{value}</Text.BodyText4>
        {subLine && (
          <Text.BodyText5 tag="div" color="grey50">
            {subLine}
          </Text.BodyText5>
        )}
      </td>
    </tr>
  )
}

export default SummaryDetailRow
